// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyAyOtLR0DNl5zbPEHJ3R8xz_5cShqqdSVA",
//   authDomain: "game7s-96d71.firebaseapp.com",
//   projectId: "game7s-96d71",
//   storageBucket: "game7s-96d71.firebasestorage.app",
//   messagingSenderId: "784895859933",
//   appId: "1:784895859933:web:8600d021f7882ec37d4f34",
//   measurementId: "G-6ZHV2PJ123"
// };


//contact us real server firebase
const firebaseConfig = {
    apiKey: "AIzaSyC3ZA9XHptwzd-rfRzJtcQAuGs89wKlVOo",
    authDomain: "game-7-7ec4d.firebaseapp.com",
    projectId: "game-7-7ec4d",
    storageBucket: "game-7-7ec4d.firebasestorage.app",
    messagingSenderId: "503468213047",
    appId: "1:503468213047:web:4f8f709b1da9ecc57050b2",
    measurementId: "G-XMV5RQK0K7"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db };

